export const toggleChangedIds = (current: string[], next: string[], toggleId: (id: string) => void): string[] => {
  const unique = [...new Set(next)];
  const currentSet = new Set(current);
  const nextSet = new Set(unique);
  [...current.filter((id) => !nextSet.has(id)), ...unique.filter((id) => !currentSet.has(id))].forEach(toggleId);
  return unique;
};
